export default __webpack_public_path__ + "static/media/bg_map_2.9526daba.png";